import { InputHTMLAttributes, forwardRef } from 'react'
import styled, { css } from 'styled-components'
import CheckBoxIcon from 'svgIcons/CheckBox'

type TStyledProps = {
  buttonSize: 'small' | 'medium'
  isErrors?: boolean
}

interface IFProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  buttonId: string
  buttonSize?: 'small' | 'medium'
  isErrors?: boolean
}

const PredictionInputCheckbox = forwardRef<HTMLInputElement, IFProps>(
  (
    { buttonId, buttonSize = 'medium', label, isErrors, ...restInputProps },
    inputCheckboxRef,
  ) => {
    return (
      <StyledWrapper isErrors={isErrors} buttonSize={buttonSize}>
        <input
          type="checkbox"
          ref={inputCheckboxRef}
          id={buttonId}
          className={isErrors ? 'error' : ''}
          {...restInputProps}
        />
        <label htmlFor={buttonId}>
          <CheckBoxIcon />
        </label>
        {label && (
          <p
            className={
              buttonSize === 'small'
                ? 'label-item-select'
                : 'label-option-check'
            }
          >
            {label}
          </p>
        )}
      </StyledWrapper>
    )
  },
)

export default PredictionInputCheckbox

const StyledWrapper = styled.div<TStyledProps>`
  ${({ theme, buttonSize, isErrors }) => css`
    display: flex;
    align-items: center;

    & > input {
      display: none;

      &:checked + label {
        color: ${theme.color.primary_2};

        svg {
          display: block;
        }
      }
    }

    & > label {
      width: ${buttonSize === 'small' ? '18px' : '23px'};
      height: ${buttonSize === 'small' ? '18px' : '23px'};
      outline: 1px solid ${isErrors ? theme.color.error_1 : theme.line.line_2};
      border-radius: 5px;
      background-color: ${theme.background.bg_8};
      flex-shrink: 0;
      cursor: pointer;

      svg {
        width: 100%;
        height: 100%;
        display: none;
      }
    }

    & > p {
      margin-left: 8px;
      text-align: left;

      &.label-item-select {
        width: 100%;
        height: 20px;
        font-size: 14px;
        font-weight: normal;
        line-height: 18px;
        letter-spacing: -0.56px;
        color: ${isErrors ? theme.color.error_1 : theme.color.text_1};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      &.label-option-check {
        height: 23px;
        font-size: 16px;
        font-weight: 500;
        line-height: 23px;
        letter-spacing: -0.64px;
        color: ${isErrors ? theme.color.error_1 : theme.color.text_1};
      }
    }
  `}
`
